
import { useState } from 'react';
import { supabase } from '@/integrations/supabase/client';
import type { Application } from '@/types/database.types';
import type { Json } from '@/integrations/supabase/types';

export const useCreateApplication = () => {
  const [isCreating, setIsCreating] = useState(false);

  const createNewApplication = async (userId: string): Promise<Application | null> => {
    try {
      setIsCreating(true);
      
      // Base application with default values
      const newApplication = {
        user_id: userId,
        status: 'draft',
        progress: 0,
        additional_contacts: [] as Json,
        additional_schedules: [] as Json[],
        // Initialize array fields as string arrays to match database expectations
        // Need to use 'string[]' type here instead of empty arrays for TypeScript type checking
        desired_medical_carriers: [] as any, // Using 'any' to fix type mismatch
        desired_ancillary_carriers: [] as any, // Using 'any' to fix type mismatch
        other_documents: [] as any, // Using 'any' to fix type mismatch
        states_of_operation: [] as any, // Using 'any' to fix type mismatch
        states_with_employees: [] as any, // Using 'any' to fix type mismatch
        top_3_peo_needs: [] as any, // Using 'any' to fix type mismatch
        preferred_peos: [] as any, // Using 'any' to fix type mismatch
        excluded_peos: [] as any, // Using 'any' to fix type mismatch
        needs_guidance: true
      };
      
      const { data, error } = await supabase
        .from('applications')
        .insert(newApplication)
        .select()
        .single();
      
      if (error) {
        console.error('Error creating application:', error);
        throw error;
      }
      
      return data as unknown as Application;
    } catch (error) {
      console.error('Error creating application:', error);
      throw error;
    } finally {
      setIsCreating(false);
    }
  };
  
  return {
    createNewApplication,
    isCreating
  };
};
